import React from 'react'

const VideoSkeleton = () => {
  return (
    <div className="w-full h-[200px] rounded-xl inset-0 flex items-center justify-center bg-[#2D4F71] animate-pulse">
        
    </div>
  )
}

export default VideoSkeleton